import React from "react";
import { RewardPointsSource } from "../interface";

const SOURCE_FILTERS: { label: string; value: RewardPointsSource | "" }[] = [
    { label: "All Sources", value: "" },
    { label: "Booking Platform Fee", value: "platform_fee" },
    { label: "Preferred Brand Bonus", value: "alcohol" },
    { label: "HO Admin", value: "admin" },
    { label: "Subscription Waived", value: "subscription" },
];

interface SourceFilterSelectProps {
    value: RewardPointsSource | "";
    onChange: (value: RewardPointsSource | "") => void;
}

const SourceFilterSelect: React.FC<SourceFilterSelectProps> = ({ value, onChange }) => {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value as RewardPointsSource | "")}
            className="appearance-none bg-white border border-gray-200 shadow-sm rounded-full px-5 py-3 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-primary-red"
        >
            {SOURCE_FILTERS.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default SourceFilterSelect;
